import React from 'react';

export const useStateWithLocalStorage = ({ key, defaultValue }) => {
  const [value, setValue] = React.useState(JSON.parse(localStorage.getItem(key)) || defaultValue);
  React.useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [value]);
  return [value, setValue];
};
